import React, { useState } from "react";
import {
    Settings as SettingsIcon,
    Building2,
    Heart,
    Bell,
    CreditCard,
    ShieldCheck,
    SlidersHorizontal,
    Save,
    Upload,
    Globe,
    Mail,
    Phone,
    MapPin,
    Lock,
    Smartphone,
    MessageSquare,
    CheckCircle,
    Eye,
    EyeOff,
} from "lucide-react";

function Settings() {
    const [activeTab, setActiveTab] = useState("general");

    const [showRazorpaySecret, setShowRazorpaySecret] = useState(false);

    const [settings, setSettings] = useState({
        // General
        companyName: "Jodi Point Matrimonial Services",
        website: "https://jodipoint.com",
        email: "info@jodipoint.com",
        mobile: "+91 98765 43210",
        address:
            "123, Main Road, Erode, Tamil Nadu - 638001",
        timezone: "Asia/Kolkata",
        dateFormat: "DD-MM-YYYY",
        language: "English",

        // Matrimony
        profileApproval: true,
        horoscope: true,
        profilePhotoRequired: true,
        memberRegistration: true,
        autoMatch: true,
        mobileVerification: true,
        emailVerification: false,

        // Notifications
        smsNotification: true,
        emailNotification: true,
        whatsappNotification: true,
        newRegistrationNotification: true,
        paymentNotification: true,
        enquiryNotification: true,
        matchNotification: true,

        // Payment
        currency: "INR",
        gst: "18",
        paymentGateway: "Razorpay",
        razorpayKeyId: "",
        razorpaySecret: "",
        paymentMode: "Test",

        // Security
        sessionTimeout: "30",
        loginAttempts: "5",
        otpExpiry: "5",
        passwordLength: "8",
        twoFactor: false,

        // System
        maintenanceMode: false,
        defaultLanguage: "English",
        allowRegistration: true,
        showContactDetails: true,
    });

    const updateSetting = (name, value) => {
        setSettings((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSave = () => {
        alert("Settings saved successfully.");
    };

    const tabs = [
        {
            id: "general",
            label: "General Settings",
            icon: Building2,
        },
        {
            id: "matrimony",
            label: "Matrimony Settings",
            icon: Heart,
        },
        {
            id: "notifications",
            label: "Notifications",
            icon: Bell,
        },
        {
            id: "payment",
            label: "Payment Settings",
            icon: CreditCard,
        },
        {
            id: "security",
            label: "Security",
            icon: ShieldCheck,
        },
        {
            id: "system",
            label: "System Settings",
            icon: SlidersHorizontal,
        },
    ];

    return (
        <div className="settings-page">

            {/* HEADER */}
            <div className="settings-page-header">
                <div>
                    <h1>Settings</h1>
                    <p>
                        Manage your Jodi Point matrimonial platform
                        configuration.
                    </p>
                </div>

                <button
                    className="settings-save-btn"
                    onClick={handleSave}
                >
                    <Save size={17} />
                    Save Changes
                </button>
            </div>

            {/* SETTINGS LAYOUT */}
            <div className="settings-layout">

                {/* SIDEBAR */}
                <div className="settings-sidebar">

                    <div className="settings-sidebar-title">
                        <SettingsIcon size={17} />
                        Settings
                    </div>

                    <div className="settings-tabs">

                        {tabs.map((tab) => {
                            const Icon = tab.icon;

                            return (
                                <button
                                    key={tab.id}
                                    className={`settings-tab ${
                                        activeTab === tab.id
                                            ? "active"
                                            : ""
                                    }`}
                                    onClick={() =>
                                        setActiveTab(tab.id)
                                    }
                                >
                                    <Icon size={18} />
                                    <span>{tab.label}</span>
                                </button>
                            );
                        })}

                    </div>

                </div>

                {/* CONTENT */}
                <div className="settings-content">

                    {/* GENERAL SETTINGS */}
                    {activeTab === "general" && (
                        <div className="settings-section">

                            <SettingsSectionHeader
                                icon={<Building2 size={20} />}
                                title="General Settings"
                                description="Manage your company and contact information."
                            />

                            <div className="settings-logo-section">

                                <div className="settings-logo-preview">
                                    <img
                                        src="/logo.png"
                                        alt="Jodi Point"
                                    />
                                </div>

                                <div className="settings-logo-info">
                                    <h3>Company Logo</h3>
                                    <p>
                                        Recommended size 300 × 100 px.
                                        PNG or JPG format.
                                    </p>

                                    <button className="upload-logo-btn">
                                        <Upload size={15} />
                                        Upload Logo
                                    </button>
                                </div>

                            </div>

                            <div className="settings-form-grid">

                                <InputField
                                    label="Company Name"
                                    value={settings.companyName}
                                    onChange={(value) =>
                                        updateSetting(
                                            "companyName",
                                            value
                                        )
                                    }
                                    required
                                />

                                <InputField
                                    label="Website"
                                    value={settings.website}
                                    onChange={(value) =>
                                        updateSetting(
                                            "website",
                                            value
                                        )
                                    }
                                    icon={<Globe size={15} />}
                                />

                                <InputField
                                    label="Email Address"
                                    value={settings.email}
                                    onChange={(value) =>
                                        updateSetting(
                                            "email",
                                            value
                                        )
                                    }
                                    icon={<Mail size={15} />}
                                />

                                <InputField
                                    label="Mobile Number"
                                    value={settings.mobile}
                                    onChange={(value) =>
                                        updateSetting(
                                            "mobile",
                                            value
                                        )
                                    }
                                    icon={<Phone size={15} />}
                                />

                                <div className="settings-form-group full-width">
                                    <label>
                                        Company Address
                                    </label>

                                    <div className="settings-input-icon">
                                        <MapPin size={15} />

                                        <textarea
                                            value={settings.address}
                                            onChange={(e) =>
                                                updateSetting(
                                                    "address",
                                                    e.target.value
                                                )
                                            }
                                            rows="3"
                                        />
                                    </div>
                                </div>

                            </div>

                        </div>
                    )}

                    {/* MATRIMONY SETTINGS */}
                    {activeTab === "matrimony" && (
                        <div className="settings-section">

                            <SettingsSectionHeader
                                icon={<Heart size={20} />}
                                title="Matrimony Settings"
                                description="Configure member registration and matrimonial profile settings."
                            />

                            <div className="settings-option-list">

                                <ToggleSetting
                                    title="Profile Approval Required"
                                    description="New profiles must be approved by admin before becoming visible."
                                    checked={settings.profileApproval}
                                    onChange={(value) =>
                                        updateSetting(
                                            "profileApproval",
                                            value
                                        )
                                    }
                                />

                                <ToggleSetting
                                    title="Horoscope"
                                    description="Allow members to add horoscope information to their profiles."
                                    checked={settings.horoscope}
                                    onChange={(value) =>
                                        updateSetting(
                                            "horoscope",
                                            value
                                        )
                                    }
                                />

                                <ToggleSetting
                                    title="Profile Photo Required"
                                    description="Require members to upload a profile photo during registration."
                                    checked={
                                        settings.profilePhotoRequired
                                    }
                                    onChange={(value) =>
                                        updateSetting(
                                            "profilePhotoRequired",
                                            value
                                        )
                                    }
                                />

                                <ToggleSetting
                                    title="Member Registration"
                                    description="Allow new members to register through the application."
                                    checked={
                                        settings.memberRegistration
                                    }
                                    onChange={(value) =>
                                        updateSetting(
                                            "memberRegistration",
                                            value
                                        )
                                    }
                                />

                                <ToggleSetting
                                    title="Automatic Match"
                                    description="Automatically generate profile matches based on preferences."
                                    checked={settings.autoMatch}
                                    onChange={(value) =>
                                        updateSetting(
                                            "autoMatch",
                                            value
                                        )
                                    }
                                />

                                <ToggleSetting
                                    title="Mobile Verification"
                                    description="Require mobile OTP verification during registration."
                                    checked={
                                        settings.mobileVerification
                                    }
                                    onChange={(value) =>
                                        updateSetting(
                                            "mobileVerification",
                                            value
                                        )
                                    }
                                />

                                <ToggleSetting
                                    title="Email Verification"
                                    description="Require email verification during registration."
                                    checked={
                                        settings.emailVerification
                                    }
                                    onChange={(value) =>
                                        updateSetting(
                                            "emailVerification",
                                            value
                                        )
                                    }
                                />

                            </div>

                        </div>
                    )}

                    {/* NOTIFICATIONS */}
                    {activeTab === "notifications" && (
                        <div className="settings-section">

                            <SettingsSectionHeader
                                icon={<Bell size={20} />}
                                title="Notification Settings"
                                description="Control SMS, email and WhatsApp notifications."
                            />

                            <div className="notification-group">

                                <h3>
                                    <MessageSquare size={16} />
                                    Notification Channels
                                </h3>

                                <ToggleSetting
                                    title="SMS Notifications"
                                    description="Send notifications through SMS."
                                    checked={
                                        settings.smsNotification
                                    }
                                    onChange={(value) =>
                                        updateSetting(
                                            "smsNotification",
                                            value
                                        )
                                    }
                                />

                                <ToggleSetting
                                    title="Email Notifications"
                                    description="Send notifications through email."
                                    checked={
                                        settings.emailNotification
                                    }
                                    onChange={(value) =>
                                        updateSetting(
                                            "emailNotification",
                                            value
                                        )
                                    }
                                />

                                <ToggleSetting
                                    title="WhatsApp Notifications"
                                    description="Send important notifications through WhatsApp."
                                    checked={
                                        settings.whatsappNotification
                                    }
                                    onChange={(value) =>
                                        updateSetting(
                                            "whatsappNotification",
                                            value
                                        )
                                    }
                                />

                            </div>

                            <div className="notification-group">

                                <h3>
                                    <Bell size={16} />
                                    Notification Events
                                </h3>

                                <ToggleSetting
                                    title="New Registration"
                                    description="Notify admin when a new member registers."
                                    checked={
                                        settings.newRegistrationNotification
                                    }
                                    onChange={(value) =>
                                        updateSetting(
                                            "newRegistrationNotification",
                                            value
                                        )
                                    }
                                />

                                <ToggleSetting
                                    title="Payment Notification"
                                    description="Notify admin and member after successful payment."
                                    checked={
                                        settings.paymentNotification
                                    }
                                    onChange={(value) =>
                                        updateSetting(
                                            "paymentNotification",
                                            value
                                        )
                                    }
                                />

                                <ToggleSetting
                                    title="Enquiry Notification"
                                    description="Notify branch staff when a new enquiry is created."
                                    checked={
                                        settings.enquiryNotification
                                    }
                                    onChange={(value) =>
                                        updateSetting(
                                            "enquiryNotification",
                                            value
                                        )
                                    }
                                />

                                <ToggleSetting
                                    title="Match Notification"
                                    description="Notify members when new matching profiles are available."
                                    checked={
                                        settings.matchNotification
                                    }
                                    onChange={(value) =>
                                        updateSetting(
                                            "matchNotification",
                                            value
                                        )
                                    }
                                />

                            </div>

                        </div>
                    )}

                    {/* PAYMENT */}
                    {activeTab === "payment" && (
                        <div className="settings-section">

                            <SettingsSectionHeader
                                icon={<CreditCard size={20} />}
                                title="Payment Settings"
                                description="Configure membership payment and gateway settings."
                            />

                            <div className="settings-form-grid">

                                <SelectField
                                    label="Currency"
                                    value={settings.currency}
                                    onChange={(value) =>
                                        updateSetting(
                                            "currency",
                                            value
                                        )
                                    }
                                    options={[
                                        {
                                            label: "Indian Rupee (INR)",
                                            value: "INR",
                                        },
                                        {
                                            label: "US Dollar (USD)",
                                            value: "USD",
                                        },
                                        {
                                            label: "Euro (EUR)",
                                            value: "EUR",
                                        },
                                    ]}
                                />

                                <InputField
                                    label="GST (%)"
                                    value={settings.gst}
                                    onChange={(value) =>
                                        updateSetting(
                                            "gst",
                                            value
                                        )
                                    }
                                />

                                <SelectField
                                    label="Payment Gateway"
                                    value={settings.paymentGateway}
                                    onChange={(value) =>
                                        updateSetting(
                                            "paymentGateway",
                                            value
                                        )
                                    }
                                    options={[
                                        {
                                            label: "Razorpay",
                                            value: "Razorpay",
                                        },
                                        {
                                            label: "PhonePe",
                                            value: "PhonePe",
                                        },
                                        {
                                            label: "Cashfree",
                                            value: "Cashfree",
                                        },
                                    ]}
                                />

                                <SelectField
                                    label="Payment Mode"
                                    value={settings.paymentMode}
                                    onChange={(value) =>
                                        updateSetting(
                                            "paymentMode",
                                            value
                                        )
                                    }
                                    options={[
                                        {
                                            label: "Test",
                                            value: "Test",
                                        },
                                        {
                                            label: "Live",
                                            value: "Live",
                                        },
                                    ]}
                                />

                                <InputField
                                    label="Razorpay Key ID"
                                    value={settings.razorpayKeyId}
                                    onChange={(value) =>
                                        updateSetting(
                                            "razorpayKeyId",
                                            value
                                        )
                                    }
                                    placeholder="Enter Razorpay Key ID"
                                    fullWidth
                                />

                                <div className="settings-form-group">
                                    <label>
                                        Razorpay Key Secret
                                    </label>

                                    <div className="settings-input-icon">
                                        <Lock size={15} />

                                        <input
                                            type={
                                                showRazorpaySecret
                                                    ? "text"
                                                    : "password"
                                            }
                                            value={
                                                settings.razorpaySecret
                                            }
                                            onChange={(e) =>
                                                updateSetting(
                                                    "razorpaySecret",
                                                    e.target.value
                                                )
                                            }
                                            placeholder="Enter Razorpay Key Secret"
                                        />

                                        <button
                                            type="button"
                                            className="password-toggle"
                                            onClick={() =>
                                                setShowRazorpaySecret(
                                                    !showRazorpaySecret
                                                )
                                            }
                                        >
                                            {showRazorpaySecret ? (
                                                <EyeOff size={15} />
                                            ) : (
                                                <Eye size={15} />
                                            )}
                                        </button>
                                    </div>
                                </div>

                            </div>

                            <div className="payment-warning">
                                <ShieldCheck size={18} />

                                <div>
                                    <strong>
                                        Payment Security
                                    </strong>

                                    <p>
                                        Never expose payment gateway
                                        secret keys in frontend code.
                                        Store them securely on your
                                        backend/server.
                                    </p>
                                </div>
                            </div>

                        </div>
                    )}

                    {/* SECURITY */}
                    {activeTab === "security" && (
                        <div className="settings-section">

                            <SettingsSectionHeader
                                icon={<ShieldCheck size={20} />}
                                title="Security Settings"
                                description="Manage login, session and account security."
                            />

                            <div className="settings-form-grid">

                                <SelectField
                                    label="Session Timeout"
                                    value={settings.sessionTimeout}
                                    onChange={(value) =>
                                        updateSetting(
                                            "sessionTimeout",
                                            value
                                        )
                                    }
                                    options={[
                                        {
                                            label: "15 Minutes",
                                            value: "15",
                                        },
                                        {
                                            label: "30 Minutes",
                                            value: "30",
                                        },
                                        {
                                            label: "60 Minutes",
                                            value: "60",
                                        },
                                        {
                                            label: "120 Minutes",
                                            value: "120",
                                        },
                                    ]}
                                />

                                <SelectField
                                    label="Login Attempt Limit"
                                    value={settings.loginAttempts}
                                    onChange={(value) =>
                                        updateSetting(
                                            "loginAttempts",
                                            value
                                        )
                                    }
                                    options={[
                                        {
                                            label: "3 Attempts",
                                            value: "3",
                                        },
                                        {
                                            label: "5 Attempts",
                                            value: "5",
                                        },
                                        {
                                            label: "10 Attempts",
                                            value: "10",
                                        },
                                    ]}
                                />

                                <SelectField
                                    label="OTP Expiry"
                                    value={settings.otpExpiry}
                                    onChange={(value) =>
                                        updateSetting(
                                            "otpExpiry",
                                            value
                                        )
                                    }
                                    options={[
                                        {
                                            label: "3 Minutes",
                                            value: "3",
                                        },
                                        {
                                            label: "5 Minutes",
                                            value: "5",
                                        },
                                        {
                                            label: "10 Minutes",
                                            value: "10",
                                        },
                                    ]}
                                />

                                <SelectField
                                    label="Minimum Password Length"
                                    value={settings.passwordLength}
                                    onChange={(value) =>
                                        updateSetting(
                                            "passwordLength",
                                            value
                                        )
                                    }
                                    options={[
                                        {
                                            label: "6 Characters",
                                            value: "6",
                                        },
                                        {
                                            label: "8 Characters",
                                            value: "8",
                                        },
                                        {
                                            label: "10 Characters",
                                            value: "10",
                                        },
                                        {
                                            label: "12 Characters",
                                            value: "12",
                                        },
                                    ]}
                                />

                            </div>

                            <div className="settings-option-list">

                                <ToggleSetting
                                    title="Two-Factor Authentication"
                                    description="Require an additional verification step for admin login."
                                    checked={settings.twoFactor}
                                    onChange={(value) =>
                                        updateSetting(
                                            "twoFactor",
                                            value
                                        )
                                    }
                                />

                            </div>

                            <div className="security-info">

                                <div className="security-info-icon">
                                    <ShieldCheck size={21} />
                                </div>

                                <div>
                                    <strong>
                                        Admin Security
                                    </strong>

                                    <p>
                                        Use strong passwords and enable
                                        two-factor authentication for
                                        administrator accounts.
                                    </p>
                                </div>

                            </div>

                        </div>
                    )}

                    {/* SYSTEM */}
                    {activeTab === "system" && (
                        <div className="settings-section">

                            <SettingsSectionHeader
                                icon={<SlidersHorizontal size={20} />}
                                title="System Settings"
                                description="Configure application language, date and system behavior."
                            />

                            <div className="settings-form-grid">

                                <SelectField
                                    label="Time Zone"
                                    value={settings.timezone}
                                    onChange={(value) =>
                                        updateSetting(
                                            "timezone",
                                            value
                                        )
                                    }
                                    options={[
                                        {
                                            label: "India - Chennai (IST)",
                                            value: "Asia/Kolkata",
                                        },
                                        {
                                            label: "UTC",
                                            value: "UTC",
                                        },
                                        {
                                            label: "Dubai",
                                            value: "Asia/Dubai",
                                        },
                                    ]}
                                />

                                <SelectField
                                    label="Date Format"
                                    value={settings.dateFormat}
                                    onChange={(value) =>
                                        updateSetting(
                                            "dateFormat",
                                            value
                                        )
                                    }
                                    options={[
                                        {
                                            label: "DD-MM-YYYY",
                                            value: "DD-MM-YYYY",
                                        },
                                        {
                                            label: "MM-DD-YYYY",
                                            value: "MM-DD-YYYY",
                                        },
                                        {
                                            label: "YYYY-MM-DD",
                                            value: "YYYY-MM-DD",
                                        },
                                    ]}
                                />

                                <SelectField
                                    label="Default Language"
                                    value={settings.defaultLanguage}
                                    onChange={(value) =>
                                        updateSetting(
                                            "defaultLanguage",
                                            value
                                        )
                                    }
                                    options={[
                                        {
                                            label: "English",
                                            value: "English",
                                        },
                                        {
                                            label: "Tamil",
                                            value: "Tamil",
                                        },
                                    ]}
                                />

                            </div>

                            <div className="settings-option-list">

                                <ToggleSetting
                                    title="Maintenance Mode"
                                    description="Temporarily disable public access while performing system maintenance."
                                    checked={
                                        settings.maintenanceMode
                                    }
                                    onChange={(value) =>
                                        updateSetting(
                                            "maintenanceMode",
                                            value
                                        )
                                    }
                                    danger
                                />

                                <ToggleSetting
                                    title="Allow Member Registration"
                                    description="Allow new users to register from the matrimonial application."
                                    checked={
                                        settings.allowRegistration
                                    }
                                    onChange={(value) =>
                                        updateSetting(
                                            "allowRegistration",
                                            value
                                        )
                                    }
                                />

                                <ToggleSetting
                                    title="Show Contact Details"
                                    description="Allow approved members to view contact details according to their membership plan."
                                    checked={
                                        settings.showContactDetails
                                    }
                                    onChange={(value) =>
                                        updateSetting(
                                            "showContactDetails",
                                            value
                                        )
                                    }
                                />

                            </div>

                        </div>
                    )}

                </div>
            </div>

            {/* MOBILE SAVE */}
            <div className="settings-mobile-save">
                <button
                    className="settings-save-btn"
                    onClick={handleSave}
                >
                    <Save size={17} />
                    Save Changes
                </button>
            </div>

        </div>
    );
}

/* =========================
   SECTION HEADER
========================= */

function SettingsSectionHeader({
    icon,
    title,
    description,
}) {
    return (
        <div className="settings-section-header">

            <div className="settings-section-icon">
                {icon}
            </div>

            <div>
                <h2>{title}</h2>
                <p>{description}</p>
            </div>

        </div>
    );
}

/* =========================
   INPUT
========================= */

function InputField({
    label,
    value,
    onChange,
    icon,
    placeholder,
    required,
    fullWidth,
}) {
    return (
        <div
            className={`settings-form-group ${
                fullWidth ? "full-width" : ""
            }`}
        >
            <label>
                {label}

                {required && (
                    <span className="required">*</span>
                )}
            </label>

            <div className="settings-input-icon">

                {icon}

                <input
                    type="text"
                    value={value}
                    onChange={(e) =>
                        onChange(e.target.value)
                    }
                    placeholder={placeholder}
                />

            </div>
        </div>
    );
}

/* =========================
   SELECT
========================= */

function SelectField({
    label,
    value,
    onChange,
    options,
}) {
    return (
        <div className="settings-form-group">

            <label>{label}</label>

            <select
                className="settings-select-field"
                value={value}
                onChange={(e) =>
                    onChange(e.target.value)
                }
            >
                {options.map((option) => (
                    <option
                        key={option.value}
                        value={option.value}
                    >
                        {option.label}
                    </option>
                ))}
            </select>

        </div>
    );
}

/* =========================
   TOGGLE
========================= */

function ToggleSetting({
    title,
    description,
    checked,
    onChange,
    danger,
}) {
    return (
        <div className="settings-option">

            <div className="settings-option-info">

                <div className="settings-option-title">
                    {title}

                    {danger && (
                        <span className="danger-label">
                            Important
                        </span>
                    )}
                </div>

                <p>{description}</p>

            </div>

            <button
                type="button"
                className={`settings-toggle ${
                    checked ? "active" : ""
                }`}
                onClick={() => onChange(!checked)}
            >
                <span></span>
            </button>

        </div>
    );
}

export default Settings;